import { DiscoveredDevice, isFailure } from "@sportal/api";

import {
  FETCH_DISCOVERED,
  FETCH_DISCOVERED_SUCCESS,
  FETCH_DISCOVERED_FAILURE,
  DiscoveredActionTypes,
} from "./discovered.types";
import { SBThunkAction } from "../../redux.types";
import { getSubscriberId } from "../../info/info.selectors";
import {
  Notificator,
  NotificationActionTypes,
} from "../../../components/notification";

export const fetchDiscovered =
  (
    initialLoad = false
  ): SBThunkAction<void, DiscoveredActionTypes | NotificationActionTypes> =>
  async (dispatch, getState, { api }) => {
    if (initialLoad) {
      dispatch({ type: FETCH_DISCOVERED });
    }

    const subscriberId = getSubscriberId(getState());
    const result = await api.ssm.deviceRequests.getDiscovered(subscriberId);

    if (isFailure(result)) {
      dispatch(Notificator.error("failed_to_load_discovered"));
      dispatch(fetchDiscoveredFailure(result.error));
      return;
    }

    dispatch(fetchDiscoveredSuccess(result.data));
  };

export const fetchDiscoveredSuccess = (
  discovered: DiscoveredDevice[]
): DiscoveredActionTypes => ({
  type: FETCH_DISCOVERED_SUCCESS,
  payload: discovered,
});

const fetchDiscoveredFailure = (
  error: object & { code: string | number }
): DiscoveredActionTypes => ({
  type: FETCH_DISCOVERED_FAILURE,
  payload: error,
});
